import { getHttpErrorBody, getHttpErrorStatus } from '../../utils/error.utils';

export interface SimilarSupplierCandidate {
  id: string;
  name: string;
  vatNumber: string;
  email?: string | null;
  phone?: string | null;
  isActive: boolean;
}

/** Reads the backend's 409 `similar_suppliers_found` conflict off a ky HTTPError. Null for any other error shape. */
export function getSimilarSuppliersConflict(err: unknown): SimilarSupplierCandidate[] | null {
  if (getHttpErrorStatus(err) !== 409) {
    return null;
  }
  const body = getHttpErrorBody(err);
  if (!body || typeof body !== 'object') {
    return null;
  }
  const { error, candidates } = body as { error?: unknown; candidates?: unknown };
  if (error !== 'similar_suppliers_found' || !Array.isArray(candidates)) {
    return null;
  }
  return candidates as SimilarSupplierCandidate[];
}
